import "./footer.scss";
import React from "react";

export const Footer = () => {
  return (
    <div className="footer-container">
      <div className="bottom-box">
        <img src="./images/logo.png" alt="logo" width="200px" />
        <div>
          <h3>Temple hours of Operation</h3>
          <p>March 1st to October 31st: 7:00 am - 8:00 pm CST</p>
          <p>November 1st to February 28th: 7:00 am - 7:00 pm CST</p>
          <p>Monday to Friday: Closed from 12:00 pm to 3:30 pm CST</p>
          <p>Saturday and Sunday : Open all day</p>
          <p>The temple is open all day during Indian and American holidays</p>
        </div>
        <div>
          <h3>Get in touch with us</h3>
          <a>
            <span className="material-icons">call</span>
            <span>615-280-7601</span>
          </a>
          <a href="#">
            <span className="material-icons">mail</span>
            <span>umiyadhamtn@gmail.com</span>
          </a>
          <a href="https://maps.app.goo.gl/kbFTCuaeQH323H1c9" target="_blank">
            <span className="material-icons">location_on</span>
            <span>2241 Hobson Pike, Antioch, TN 37013</span>
          </a>
        </div>
      </div>
      <div className="ad">
        <p>&copy; 2024 SHREE UMIYA DHAM. All rights reserved.</p>
        <p>
          Website developed by
          <a href="https://www.nxtgenrocket.com/" target="_blank">
            Nextgen Rocket
          </a>
        </p>
      </div>
    </div>
  );
};
